module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAoUlEQVRYR+2XzQ3AIAhGywrdoct1oC7XHbpCe8LDF7HhJ4EDHjWGxxMN0n7d7zYZz3nQbN46J8WhMgCcsQRkzRz3YZxhIB1AIo3KvG4NcIZMGF39aBDjjKtWFsB7K9Co2kAZgFltrI5NWjMbSANYvQOWwlUbaIA20AbaQEkDnkY25CVMB/D0iSEGQgE8OjUgdbtiPBNvC/ZnpX9GaCj9d/wBWyROSLCS92oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/drawtool/DRAWWORD_V.png
// module id = ODn9
// module chunks = 18